
import Loading from 'vux/src/components/loading/index.vue'


export default {
components: {
Loading
},
data() {
return {
searchKeyWord: '',
loading: false,
pageSize: 8, // 每页显示数量
pageIndex: 1, //页数
totalVideos: -1, //总数
loadedVideos: 0, //已经加载的数量
hasSearched: false,
hotTags: [
'AI', 'DeepSeek','豆包','人工智能','大数据','数据分析','3D打印'
],
filters: [],
isFiltersExpanded: false, // 控制展开收起的标志
videos: []
}
},
computed: {
filteredVideos() {
return this.videos.filter(video => video.type === this.activeFilter);
},
hasMore() {
console.log(this.loadedVideos, this.totalVideos)
if (this.totalVideos == -1) return true;

return this.loadedVideos < this.totalVideos;
}
},
methods: {
selectHotTag(tag) {
this.searchKeyWord = tag;
this.handleSearch();
},
loadVideos() {

const currentItem = this.filters.find(item => item.Select == true);
if (currentItem == null) {
this.totalVideos = 0;
this.$vux.loading.hide()
return;
}

this.loading = true;

this.$tyh.SearchByContion(this.searchKeyWord, currentItem.IDCode, this.pageIndex, this.pageSize)
.then((data) => {
if (data.data.Status == 0) {
this.videos = this.videos.concat(data.data.Data.rows);
this.loadedVideos = this.videos.length;
this.totalVideos = data.data.Data.total;
}
}).finally(() => {
this.loading = false;
this.$vux.loading.hide()
});;
},
initParam() {
this.hasSearched = true;
this.pageIndex = 1;
this.totalVideos = -1;
this.loadedVideos = 0;
this.videos = [];
},
handleScroll(event) {
if (this.scrollTimer) clearTimeout(this.scrollTimer);
this.scrollTimer = setTimeout(() => {
const container = event.target;
if (container.scrollHeight - container.scrollTop <= container.clientHeight + 100) {
this.loadMore();
}
}, 200);
},
handleSearch() {

this.$vux.loading.show({
text: 'Loading'
});

if (this.searchKeyWord.trim()) {

this.initParam();

this.$tyh.SearchCourse(this.searchKeyWord)
.then((data) => {
this.filters = data.data.Data.category;
this.loadVideos();
})
}
},
loadMore() {
if (this.loading || !this.hasMore) return;

this.pageIndex++;


this.loadVideos();

},

clickFilter(IDCode) {

const currentItem = this.filters.find(item => item.IDCode === IDCode);

if (currentItem.Select) {
return;
}

this.filters = this.filters.map(item => {

if (item.Select) {
return {
...item,
Select: false
};
}

if (item.IDCode === IDCode) {
return {
...item,
Select: true
};
}

return item;
});
this.initParam();
this.loadVideos();
},
highlightKeyword(text) {
if (!this.searchKeyWord || !text) return text;

const regex = new RegExp(this.searchKeyWord, 'gi');
return text.replace("<em>", "").replace("</em>", "").replace(regex, match =>
`<span class="highlight" style="color: #ff0000 !important;">${match}</span>`
);
},
JumpVideo(IDCode, ChapterID) {
console.log(IDCode, ChapterID)
this.$router.push({
path: '/Index/Course',
name: '/Index/Course',
params: {
IDCode: IDCode,
ChapterID: ChapterID,
level1: "资源检索",
level2: "",
level3: "",
}
})
}
},
mounted() {
let search = this.$route.params.Search;
if (search) {
this.searchKeyWord = this.$route.params.Search;
this.handleSearch();
}

}
}



// WEBPACK FOOTER //
// ./src/views/Resource.vue